export default {
  UNIVERSIY: "Universität",
  FH: "FH",
  ABITUR: "Abitur",
  REALSCHULE: "Realschule",
  WERKREALSCHULE: "Werkrealschule",
  HAUPTSCHULE: "Hauptschule",
  NODEGREE: "Kein Abschluss"
};
